import Swiper from "swiper";
import { Navigation, Pagination } from "swiper/modules";

export class Carousels {
  constructor() {
    this.init();
  }
  init() {
    // testimonials
    const swiper = new Swiper(".swiper-testimonial", {
      modules: [Navigation, Pagination],
      slidesPerView: 1,
      spaceBetween: 30,
      breakpoints: {
        640: {
          slidesPerView: 2,
        },
        768: {
          slidesPerView: 3,
        },
      },
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      navigation: {
        nextEl: ".swiper-testimonial-next",
        prevEl: ".swiper-testimonial-prev",
      },
    });
  }
}
